import './parts/header';

import {
    gsap,
    Power1,
    Power3
} from "gsap";

import {
    ScrollTrigger
} from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

function windowWidth() {
    return window.innerWidth;
}

let animateSimple = document.querySelectorAll('.product-tabs__item, .list-lines__item, .list-icons__item');
function categoryAnimation() {
    if (animateSimple.length > 0) {
        gsap.utils.toArray('.category-product-right, .category-product-left').forEach(item => {
            gsap.from(item, {
                duration: 0.9,
                y: 200,
                autoAlpha: 1,
                ease: Power3.out,
                stagger: .05,
                scrollTrigger: {
                    trigger: item.parentElement,
                    scrub: 1,
                    start: "top 95%",
                    end: "70% 70%",
                },
            })
        });
    }
}

(function() {

    if (windowWidth() < 992) return;

    categoryAnimation();
}());

(function() {
    let flavors = document.querySelectorAll('.js-category-product-flavor');
    if (flavors) {
        flavors.forEach(function(flavor) {
            flavor.addEventListener('click', function() {
                let categoryProduct = this.closest('.category-product');
                let allFlavors = categoryProduct.querySelectorAll('.js-category-product-flavor');
                if (allFlavors) {
                    allFlavors.forEach(function(item) {
                        item.classList.remove('active');
                    });
                }
                this.classList.add('active');

                let dataImage = this.getAttribute('data-image');
                let dataTitle = this.getAttribute('data-title');
                let dataId = this.getAttribute('data-id');
                let dataLink = this.getAttribute('data-link');

                let imgElement = categoryProduct.querySelector('.js-category-product-image');
                let subtitleElement = categoryProduct.querySelector('.js-category-subtitle');
                if (dataImage) {
                    imgElement.setAttribute('src', dataImage);
                    subtitleElement.innerText = dataTitle;
                }

                let link = categoryProduct.querySelector('.category-product-image');
                if (link && dataLink) {
                    link.setAttribute('href', dataLink);
                }

                let textItems = categoryProduct.querySelectorAll('.category-product-left-item');
                if (textItems) {
                    textItems.forEach(function(item) {
                        dataId === item.getAttribute('data-id') ? item.classList.add('active') : item.classList.remove('active');
                    });
                }
            });
        });
    }
})();

(function() {
    document.addEventListener('DOMContentLoaded', function() {
        let categoryFilters = document.querySelectorAll('.js-category-filter');
        let categoryFiltersClear = document.querySelector('.js-filter-clear-wrapper');
        let productSections = document.querySelectorAll('.js-product-section');

        if (categoryFilters) {
            categoryFilters.forEach(function(categoryFilter) {
                categoryFilter.addEventListener('click', function() {
                    categoryFilters.forEach(function(filter) {
                        filter.classList.remove('active');
                    });
                    categoryFilter.classList.add('active');

                    let dataId = categoryFilter.dataset.id;
                    productSections.forEach(function(section) {
                        let categories = section.dataset.categories;
                        categories.indexOf(dataId) === -1 ? section.classList.add('hidden') : section.classList.remove('hidden');
                        categories.indexOf(dataId) === -1 ? section.classList.remove('filtered') : section.classList.add('filtered');
                    });

                    categoryFiltersClear.classList.remove('hidden');
                });
            });
        }

        if (categoryFiltersClear) {
            categoryFiltersClear.addEventListener('click', function() {
                categoryFilters.forEach(function(filter) {
                    filter.classList.remove('active');
                });

                productSections.forEach(function(section) {
                    section.classList.remove('hidden');
                    section.classList.remove('filtered');
                });

                categoryFiltersClear.classList.add('hidden');
            });
        }
    });
})();
